import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      listStyle: 'none',
      flexGrow: 1,
      minWidth: 0,

      marginBottom: theme.spacing(),
      '&:last-of-type': {
        marginBottom: 0,
      },
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      flexGrow: 1,
      minWidth: 0,
    },
    expired: {
      position: 'absolute',
      bottom: theme.spacing(0.5),
      right: theme.spacing(0.5),
      background: theme.palette.action.active,
      color: theme.palette.getContrastText(theme.palette.action.active),
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.shadows[4],
    },
    title: {
      ...theme.typography.body2,
      color: theme.palette.text.primary,

      '& a': {
        color: 'inherit',
      },
    },
    subtitle: {
      ...theme.typography.caption,
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.text.secondary,
    },
    previewContainer: {
      width: 50,
      maxWidth: 50,
      height: 50,
      maxHeight: 50,
      marginRight: theme.spacing(),
      borderRadius: theme.shape.borderRadius,
      position: 'relative',
    },
    preview: {
      width: 50,
      maxWidth: 50,
      height: 50,
      maxHeight: 50,
      objectFit: 'cover',
      borderRadius: theme.shape.borderRadius,
    },
    icon: {
      marginRight: theme.spacing(0.25),
    },
  }
})
